import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CategoriesBar from '../components/link/CategoriesBar';
import SearchBox from '../components/input/SearchBox';
import Topcategories from '../components/Topcategories';
import NewItemsBar from '../components/NewItemsBar';
import AppBanner from '../components/display/AppBanner';
import SEO from '../components/seo/SEO';
import Breadcrumbs from '../components/navigation/Breadcrumbs';

function Items() {
    const [searchQuery, setSearchQuery] = useState('');
    const navigate = useNavigate();

    const handleSearch = () => {
        navigate(`/itemlist?q=${encodeURIComponent(searchQuery)}`);
    };

    const handleClear = () => {
        setSearchQuery('');
    };

    return (
        <div className="container-fluid px-0 py-3">
            <SEO
                title="Browse All Toys & Collectibles | ToyTrade.pk Pakistan"
                description="Explore our complete catalog of pre-loved toys, LEGO sets, action figures, and more. Direct search and category-wise browsing for parents in Pakistan."
                canonical="https://toytrade.pk/items"
            />

            <div className="px-4 mb-4">
                <Breadcrumbs items={[]} />
                <h1 className="fw-bold mt-3">Explore Toys Catalog</h1>
                <p className="text-muted lead">Find the best deals on pre-loved toys and collectibles in Pakistan.</p>
            </div>

            <AppBanner className="mb-5" />

            <div className="container-fluid mb-4 px-4">
                <div className="row">
                    <div className="col-md-3">
                        <SearchBox
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            onSearch={handleSearch}
                            onClear={handleClear}
                        />
                        <p className="text-start mt-2 px-1" style={{ fontSize: '12px' }}>Search for an item or select from a category...</p>
                    </div>
                    <div className="col-md-9">
                        <CategoriesBar columns={9} />
                    </div>
                </div>
            </div>

            <NewItemsBar highlighted={true} />

            <Topcategories />
        </div>
    );
}


export default Items;
